import Phaser from 'phaser';

import { GAME_SCENES } from './presentation/arena-scenes';

export const LOGICAL_WIDTH = 1280;
export const LOGICAL_HEIGHT = 720;

export const createGameConfig = (parent: string | HTMLElement): Phaser.Types.Core.GameConfig => ({
  type: Phaser.AUTO,
  parent,
  width: LOGICAL_WIDTH,
  height: LOGICAL_HEIGHT,
  backgroundColor: '#07111f',
  render: {
    antialias: true,
    pixelArt: false,
    roundPixels: true,
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: LOGICAL_WIDTH,
    height: LOGICAL_HEIGHT,
    expandParent: true,
  },
  scene: GAME_SCENES,
});
